import request from '@/utils/request'

export async function getData(data) {
  return request({
    url: '/personBlackWhiteList/list',
    method: 'post',
    data,
  })
}
export async function getDetail(data) {
  return request({
    url: '/personBlackWhiteList/detail',
    method: 'get',
    params: data,
  })
}
export async function searchData(data) {
  return request({
    url: '/personBlackWhiteList/get',
    method: 'post',
    data,
  })
}
export async function createData(data) {
  return request({
    url: '/personBlackWhiteList/save',
    method: 'post',
    data,
  })
}
export async function updateData(data) {
  return request({
    url: '/personBlackWhiteList/edit',
    method: 'post',
    data,
  })
}
export async function pushData(data) {
  return request({
    url: '/personBlackWhiteList/push',
    method: 'post',
    data,
  })
}
export async function deleteData(data) {
  return request({
    url: '/personBlackWhiteList/delete',
    method: 'post',
    data,
  })
}
export async function revoke(data) {
  return request({
    url: '/personBlackWhiteList/revoke',
    method: 'post',
    data,
  })
}
export async function approvalProcess(data) {
  return request({
    url: '/v2/personBlackWhiteList/check/process/info',
    method: 'post',
    data,
  })
}
